var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('cell-header');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from './cell-label';
import { Badge } from './badge';
export var CellHeaderDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var CellLabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    line-height: 1.05em;\n  "], ["\n    line-height: 1.05em;\n  "])))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: ", ";\n    line-height: 18px;\n  "], ["\n    margin-left: ", ";\n    line-height: 18px;\n  "])), theme.UNIT(3))
});
var LabelAndBadgeStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.header(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LabelAndBadge: styled.div.attrs(cls.attr('label-and-badge'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelAndBadgeStyles),
  CellLabel: styled(CellLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CellLabelStyles),
  Badge: styled(Badge)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
export var CellHeader = function CellHeader(props) {
  var className = props.className,
      children = props.children,
      badge = props.badge;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.LabelAndBadge, null, React.createElement(My.CellLabel, null, children), badge && React.createElement(My.Badge, null, badge)));
};
CellHeader.cls = cls;
CellHeader.defaultProps = CellHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;